var _defs, _path, _path2, _path3, _path4, _rect, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path6, _path7, _path8, _path9, _polygon, _rect9, _rect10, _rect11, _line, _line2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddd;}.cls-2{fill:#d82f23;}.cls-3{fill:#444;}.cls-4{fill:#b7b7b7;}.cls-5{fill:#2d2d2d;}.cls-6{fill:#54c3ef;}.cls-7{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:15px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hospital") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.54,89.41v1.64a7.9,7.9,0,0,1-7.9,7.9H275v33.6a7.9,7.9,0,0,1-7.9,7.9H232.86a7.9,7.9,0,0,1-7.9-7.9V99h-33.6a7.9,7.9,0,0,1-7.9-7.9V89.41H73.92V492H426.08V89.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.64,48.88H275V15.27a7.9,7.9,0,0,0-7.9-7.9H232.86a7.9,7.9,0,0,0-7.9,7.9V48.88h-33.6a7.89,7.89,0,0,0-7.9,7.89V91.05a7.9,7.9,0,0,0,7.9,7.9H225v33.6a7.9,7.9,0,0,0,7.9,7.9h34.28a7.9,7.9,0,0,0,7.9-7.9V99h33.6a7.9,7.9,0,0,0,7.9-7.9V56.77A7.89,7.89,0,0,0,308.64,48.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.46,58.41H71.11a15.5,15.5,0,1,0,0,31H183.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428.89,58.41H316.54v31H428.89a15.5,15.5,0,0,0,0-31Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 390.08,
    y: 89.41,
    width: 36,
    height: 402.59
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M428.89,58.41h-36a15.5,15.5,0,0,1,0,31h36a15.5,15.5,0,0,0,0-31Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.98,
    y: 345.99,
    width: 206.04,
    height: 31.01,
    rx: 15.5,
    ry: 15.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 143.47,
    y: 177.79,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 143.47,
    y: 265.03,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 227.08,
    y: 177.79,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 227.08,
    y: 265.03,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 311.9,
    y: 177.79,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 311.9,
    y: 265.03,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.64,48.88H275V15.27a7.9,7.9,0,0,0-7.9-7.9H232.86a7.9,7.9,0,0,0-7.9,7.9V48.88h-33.6a7.89,7.89,0,0,0-7.9,7.89V91.05a7.9,7.9,0,0,0,7.9,7.9H225v33.6a7.9,7.9,0,0,0,7.9,7.9h34.28a7.9,7.9,0,0,0,7.9-7.9V99h33.6a7.9,7.9,0,0,0,7.9-7.9V56.77A7.89,7.89,0,0,0,308.64,48.88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M183.46,58.41H71.11a15.5,15.5,0,1,0,0,31H183.46Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M428.89,58.41H316.54v31H428.89a15.5,15.5,0,0,0,0-31Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M316.54,89.41v1.64a7.9,7.9,0,0,1-7.9,7.9H275v33.6a7.9,7.9,0,0,1-7.9,7.9H232.86a7.9,7.9,0,0,1-7.9-7.9V99h-33.6a7.9,7.9,0,0,1-7.9-7.9V89.41H73.92V492H426.08V89.41Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "250 377 164.96 377 164.96 492 250 492 335.04 492 335.04 377 250 377"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 164.96,
    y: 377,
    width: 85.04,
    height: 115.01
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250,
    y: 377,
    width: 85.04,
    height: 115.01
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.98,
    y: 345.99,
    width: 206.04,
    height: 31.01,
    rx: 15.5,
    ry: 15.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 228.62,
    y1: 432.05,
    x2: 228.62,
    y2: 439.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 271.38,
    y1: 432.05,
    x2: 271.38,
    y2: 439.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 143.47,
    y: 177.79,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 143.47,
    y: 265.03,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.08,
    y: 177.79,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.08,
    y: 265.03,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 311.9,
    y: 177.79,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 311.9,
    y: 265.03,
    width: 44.63,
    height: 44.63,
    rx: 9.55,
    ry: 9.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/Hospital.c13f89c1282113e8539a95c700730f64.svg";
export { ForwardRef as ReactComponent };